import { Component, OnInit } from '@angular/core';
import { LanguageService } from '@ibank-globals/language';
import { BaseComponent } from '../../../globals/classes/base.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'ibank-icon',
	template: require('./ibank-icon.component.html'),
})
export class IbankIconComponent extends BaseComponent implements OnInit {
	public comboLogoSrc: string;
	public langId: string;
	public isRebrading = AppSettings.isRebrading;

	constructor(private _langSvc: LanguageService) {
		super();
	}

	public ngOnInit() {
		this.mortalize(this._langSvc.activeLanguage$).subscribe(
			(lang) => (
				(this.comboLogoSrc = this.isRebrading
					? './Content/images/loginGR-new.svg'
					: `./Content/images/logos/light/login-logo.${lang}.png`),
				(this.langId = lang)
			)
		);
	}

	public backToNBG() {
		if (this.langId === 'el') window.open('https://www.nbg.gr/', '_blank');
		else {
			window.open('https://www.nbg.gr/en/individuals', '_blank');
		}
	}
}
